import {Action} from '@ngrx/store';
import {BijbAccount} from '../../../models/bijb-account';

export class GetCurrentAccountSuccessAction implements Action {
  public static readonly type = 'GetCurrentAccountSuccessAction';

  constructor(public account: BijbAccount) {
  }

  public type = GetCurrentAccountSuccessAction.type;
}
